export const HOSTNAME = "chokamatt.co.ke"
export const product_image_placeholder = require("./../../assets/product-placeholder.png")

const configs = [
    {
        name: "chokamatt.co.ke",
        image_horizontal: "/images/chokamatt_logo_h.png",
        image_vertical: "/images/chokamatt_logo_v.png"
    },
    {
        name: "sylink.co.ke",
        image_horizontal: "/images/sylink_logo_h.png",
        image_vertical: "/images/sylink_logo_v.png"
    },
    {
        name: "farmersworld.co.ke",
        image_horizontal: "/images/farmersworld_logo_h.png",
        image_vertical: "/images/farmersworld_logo_v.png"
    }
]

export const getLogo = (type = "horizontal") => {
    return configs.find(c => c.name === HOSTNAME)?.[`image_${type}`] || "/nav_logo.png"
}
